const Index = () => {
  return (
    <>
      <div className="d-flex justify-content-center aligin-items-center w-100">
        <div className="spinner-border loading-size text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    </>
  );
};

export default Index;
